<template>
  <div class="w-full px-20px flex-1">
    <el-form class=" mb-20px" ref="formRef" :model="form" :rules="formRule">
      <el-form-item label="更改内容" prop="title">
        <el-input v-model="form.title"></el-input>
      </el-form-item>
      <el-form-item label="扩展描述" prop="content">
        <editor-vue height="300px" v-model="form.content" :height="'100px'" /> </el-form-item>
        <el-form-item label="文件" prop="file">
          <el-upload
            class="upload-demo"
            drag
            action="/gateway/project/api/v1/uploadInfosContentImage"
            :file-list="fileList"
            :on-preview="handlePreview"
            :on-remove="handleRemove"
            :on-success="upsuccess"
            multiple>
            <i class="el-icon-upload"></i>
            <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
          </el-upload>
        
        </el-form-item>
        <el-form-item label="上传路径" prop="filepath">
            <el-select v-model="form.filepath" placeholder="请选择" style="width: 100px !important;">
                <el-option
                  v-for="item in options"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
        
        </el-form-item>
      </el-form>
    <div class="flex items-center">
      <el-button type="primary" @click="release" :loading="loading">发布</el-button>
      <el-button @click="cancel">取消</el-button>
    </div>
  </div>
</template>

<script>
import EditorVue from '@/components/editor-vue.vue'
export default {
  components: { EditorVue },
  data() {
    return {
      loading: false,
      options:[
       {
          value: '1',
          label: '根目录'
        },
      ],
      form: {
        title: '',
        content: '',
        file: '',
        filepath: ''
      },
      fileList: [],
      formRule: {
        title: [{ required: true, message: '请输入标题', trigger: 'blur' }],
        content: [{ required: true, message: '请输入内容', trigger: 'blur' }]
      }
    }
  },
  computed: {
    project_id() { return this.$store.state.project.projectId }
  },
  created() { },
  mounted() { },
  methods: {
    // 发布
    release() {
      this.$refs['formRef'].validate((valid) => {
        console.log(this.fileList);
        
        if (valid) {
          const { title, content } = this.form
          this.loading = true
          this.$api.project
            .createissue({
              title,
              content,
              project_id: this.project_id
            })
            .then((res) => {
              const { message } = res
              if (message === 'Success') {
                this.$message.success('发布成功')
                this.$emit('fresh')
              }
            })
            .finally(() => {
              this.loading = false
            })
        }
      })
    },
    // 取消
    cancel() {
      this.$emit('cancel')
    },
    handlePreview(file) {
      console.log(file);
    },
    handleRemove(file){
      console.log(file);
      
    },
    upsuccess(e){
      console.log(e);
      
    }
  }
}
</script>
<style lang="scss" scoped>

</style>
